import * as _ from "lodash";

export abstract class Entity<T> {
	public assign(data: Partial<T> = {}): this {
		_.assign(this, data);
		return this;
	}
}



// WEBPACK FOOTER //
// ./src/lib/stores/Entity.ts